<template>
    <div class="buoy" @click="gotoApp" :style="{top:(mytop)+'px'}">在APP打开</div>
</template>

<script>
import  Bus from './bus.js'
export default {
    props:{
        isView:Boolean,
        hasNotice:Boolean,        
    },
    data(){
        return {
            mytop:110,
            navandDif:70,
            sortHig:40,
            noticeHig:0
        }
    },
    mounted(){
        let me = this;        
        Bus.$on('sortChange', (tabName) => {            
            if(tabName!=="all"){
                me.sortHig=0
            }else{
                me.sortHig=40
            }
            me.calTop()            
        })
        
        setTimeout(function(){            
            AppendTrack("my_orders", "app_transfer_icon", "h5_minapp_my_orders920", "^浮标曝光^")
        },1000)
        
    },
    methods:{
        gotoApp(){            
            window.location.href="https://m.17u.cn/app/links/orderCenter/all?refresh=1&backToMine=1&wakeRefid=1559893071"
            AppendTrack("my_orders", "app_transfer_icon", "h5_minapp_my_orders920", "^浮标点击^")
        },
        calTop(){
            this.mytop=this.navandDif+this.sortHig+this.noticeHig
        }
    }
}
</script>

<style scoped>
  .buoy{
      position: fixed;
      right: 0px;
      top: 110px;
      width: 75.5px;
      height: 27px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      background-color:#EB604F;
      z-index: 999;
      color:#FEFEFE ;
      font-family: PingFang-SC-Medium;
      font-weight: medium;
      font-size: 12px;
      line-height: 27px;
  }
</style>


// WEBPACK FOOTER //
// src/components/toappbuoy.vue